<template>
  <article>
    <div class="article-left">
      <h3><a :href="hotArticleLeft.url">{{ hotArticleLeft.stitle }}</a></h3>
      <ul>
        <li v-for="(item, index) in hotArticleLeftList" :key="index">
          <a :href="item.url" :title="item.title">{{ item.title }}</a>
        </li>
      </ul>
    </div>
    <div class="article-right">
      <h3><a :href="hotArticleRight.url">{{ hotArticleRight.stitle }}</a></h3>
      <ul>
        <li v-for="(item, index) in hotArticleRightList" :key="index">
          <a :href="item.url" :title="item.title">{{ item.title }}</a>
        </li>
      </ul>
    </div>
  </article>
</template>

<script>
import { getArticle } from 'js/getArticle.js'
export default {
  name: 'Hotarticle',
  data () {
    return {
      hotArticleLeft: {},
      hotArticleRight: {},
      hotArticleLeftList: [],
      hotArticleRightList: []
    }
  },
  created () {
    this.getHotArticle()
  },
  methods: {
    getHotArticle () {
      let _this = this
      getArticle('2573,9605,9606,9607,11700', 1, '_WWW').then(response => {
        _this.hotArticleLeft = response[0]
      })
      getArticle('2697,2698', 1, '_WWW').then(response => {
        _this.hotArticleLeftList.push(response[0])
      })
      getArticle('2643,2644,2704,2705', 1, '_WWW').then(response => {
        _this.hotArticleLeftList.push(response[0])
      })
      getArticle('1069,1070, 1076,1077,1078', 1, '_WWW').then(response => {
        _this.hotArticleLeftList.push(response[0])
      })
      getArticle('2601,982,2598,9619,9705', 1, '_WWW').then(response => {
        _this.hotArticleLeftList.push(response[0])
      })
      getArticle('1071,1294', 1, '_WWW').then(response => {
        _this.hotArticleRight = response[0]
      })
      getArticle('2675,5862,2677', 1, '_WWW').then(response => {
        _this.hotArticleRightList.push(response[0])
      })
      getArticle('2716,2717,10520,10521,944', 1, '_WWW').then(response => {
        _this.hotArticleRightList.push(response[0])
      })
      getArticle('927,9599,2594,2596', 1, '_WWW').then(response => {
        _this.hotArticleRightList.push(response[0])
      })
      getArticle('979,9627,980, 9597,9602', 1, '_WWW').then(response => {
        _this.hotArticleRightList.push(response[0])
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
article
  width: 750px
  height: 138px
  margin: 0 8px
  font-size: 14px
  float: left
  display: flex
  .article-left
    flex: 1
    display: flex
    padding-top 10px
    flex-direction: column
    h3
      flex: 1
      a
        height: 40px
        line-height: 40px
        overflow: hidden
        line-height: 40px
        color: $themeColor
        font-size: 18px
        font-weight: 400
        &:hover
          text-decoration: underline
    ul
      flex: 3
      flex-direction: column
      display: flex
      li
        flex: 1
        background: url(http://images.xdf.cn/school/middleschool/static/images/dian.jpg) no-repeat 4px 12px;
        padding-left: 14px
        align-items: center
        display: flex
        a
          color: #7a7a7a
          overflow: hidden
          white-space: nowrap
          text-overflow: ellipsis
          width: 350px
          &:hover
            color: $themeColor
            text-decoration: underline
  .article-right
    flex: 1
    display: flex
    padding-top 10px
    flex-direction: column
    h3
      flex: 1
      a
        height: 40px
        line-height: 40px
        overflow: hidden
        color: $themeColor
        font-size: 18px
        font-weight: 400
        &:hover
          text-decoration: underline
    ul
      flex: 3
      flex-direction: column
      display: flex
      li
        flex: 1
        background: url(http://images.xdf.cn/school/middleschool/static/images/dian.jpg) no-repeat 4px 12px;
        padding-left: 14px
        align-items: center
        display: flex
        a
          white-space: nowrap
          text-overflow: ellipsis
          width: 350px
          color: #7a7a7a
          overflow: hidden
          &:hover
            color: $themeColor
            text-decoration: underline
</style>



// WEBPACK FOOTER //
// src/pages/gobroad/components/swiper/components/Hotarticle.vue